import { render, staticRenderFns } from "./postReport.vue?vue&type=template&id=44b59bb4&scoped=true"
import script from "./postReport.vue?vue&type=script&lang=js"
export * from "./postReport.vue?vue&type=script&lang=js"
import style0 from "./postReport.vue?vue&type=style&index=0&id=44b59bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b59bb4",
  null
  
)

export default component.exports